export const fustionColorPalette = {
  neutral_white: "#ffffff",
  neutral50: "#fbfbfb",
  neutral100: "#f4f4f4",
  neutral200: "#e4e4e4",
  neutral300: "#d1d1d1",
  neutral400: "#bbbbbb",
  neutral500: "#8d8d8d",
  neutral600: "#747474",
  neutral700: "#555555",
  neutral800: "#464646",
  neutral900: "#2d2d2d",
  neutral_black: "#121212",
  blue50: "#ecf3fb",
  blue100: "#d8e7f9",
  blue200: "#a4c9f5",
  blue300: "#7db3f2",
  blue400: "#569cef",
  blue500: "#3885e1",
  blue600: "#2e70bd",
  blue700: "#21528c",
  blue800: "#1d4678",
  blue900: "#102641",
  turquoise50: "#eef9ff",
  turquoise100: "#d3effc",
  turquoise200: "#8cd3f5",
  turquoise300: "#1fbcf8",
  turquoise400: "#1ba9e0",
  turquoise500: "#199acc",
  turquoise600: "#147aa2",
  turquoise700: "#0f5e7c",
  turquoise800: "#0c4c64",
  turquoise900: "#062835",
  magenta50: "#fcf2fd",
  magenta100: "#f9e4fa",
  magenta200: "#efb3f1",
  magenta300: "#e88feb",
  magenta400: "#e273e6",
  magenta500: "#dc55e0",
  magenta600: "#b041b3",
  magenta700: "#8c2f8e",
  magenta800: "#7a267b",
  magenta900: "#3e133f",
  yellow50: "#fff8dd",
  yellow100: "#fee998",
  yellow200: "#fdd746",
  yellow300: "#eebf08",
  yellow400: "#d7ad0a",
  yellow500: "#af8b01",
  yellow600: "#896f07",
  yellow700: "#66561c",
  yellow800: "#514416",
  yellow900: "#2b250c",
  orange50: "#fef7ef",
  orange100: "#fee6c7",
  orange200: "#ffb86e",
  orange300: "#f79845",
  orange400: "#e88534",
  orange500: "#d6772d",
  orange600: "#aa5f27",
  orange700: "#7f4a23",
  orange800: "#633c20",
  orange900: "#332115",
  green50: "#f5fbf9",
  green100: "#d8eee6",
  green200: "#98d2bd",
  green300: "#6bbfa1",
  green400: "#48af8a",
  green500: "#2aa277",
  green600: "#1e815d",
  green700: "#176348",
  green800: "#124f39",
  green900: "#0a2a1f",
  red50: "#fdf7f7",
  red100: "#f9e5e3",
  red200: "#efb9b4",
  red300: "#e99b93",
  red400: "#e3837a",
  red500: "#e35a4d",
  red600: "#d23627",
  red700: "#aa2e23",
  red800: "#82231b",
  red900: "#48130f",
  "transparent-white_0pct": "#ffffff00",
  "transparent-white_12pct": "#ffffff1f",
  "transparent-white_72pct": "#ffffffb8",
  "transparent-black_12pct": "#1212121f",
  "transparent-black_20pct": "#12121233",
  "transparent-black_72pct": "#121212b8",
  "transparent-blue900_0pct": "#10264100",
  "transparent-blue900_4pct": "#1026410a",
  "transparent-blue900_8pct": "#10264114",
  "transparent-blue900_12pct": "#1026411f",
  "transparent-blue900_20pct": "#10264133",
  "transparent-blue900_90pct": "#102641e5",
  "transparent-turquoise200_0pct": "#8cd3f500",
  "transparent-turquoise200_8pct": "#8cd3f514",
  "transparent-turquoise200_12pct": "#8cd3f51f",
  "transparent-turquoise300_16pct": "#1fbcf829",
  "transparent-turquoise300_24pct": "#1fbcf83d",
  "transparent-turquoise300_48pct": "#1fbcf87a",
  "transparent-turquoise400_24pct": "#1ba9e03d",
  "surface-bg-01": "#fbfbfb",
  "surface-bg-02": "#ffffff",
  "surface-bg-03": "#f4f4f4",
  "surface-inverse-bg-01": "#102641",
  "surface-inverse-bg-02": "#21528c",
  "surface-inverse-bg-03": "#2e70bd",
  "surface-inverse-bg-04": "#2d2d2d",
  "text-primary": "#102641",
  "text-inverse-primary": "#ffffff",
  "text-secondary": "#555555",
  "text-inverse-secondary": "#e4e4e4",
  "text-error": "#d23627",
  "text-inverse-error": "#e35a4d",
  "text-hover-blue700": "#21528c",
  "text-inverse-hover-turquoise200": "#8cd3f5",
  "accessibility-focusRing": "#3885e1",
  "accessibility-menu-focusRing": "#2e70bd",
  "accessibility-inverse-focusRing": "#1fbcf8",
  "accessibility-inverse-menu-focusRing": "#147aa2",
  inactive02: "#e4e4e4",
  inactive03: "#d1d1d1",
  inactive04: "#bbbbbb",
  inactive05: "#8d8d8d",
  inactive06: "#747474",
  "button-content": "#102641",
  "button-content-inactive-strong": "#747474",
  "button-content-inactive-subtle": "#8d8d8d",
  "button-inverse-content": "#ffffff",
  "button-content_turquoise200": "#8cd3f5",
  "button-primary-bg-active": "#102641",
  "button-primary-bg-hover": "#1d4678",
  "button-primary-bg-focused": "#102641",
  "button-primary-bg-pressed": "#21528c",
  "button-bg-inactive": "#d1d1d1",
  "button-secondary-bg-active": "#10264100",
  "button-secondary-bg-hover": "#102641",
  "button-secondary-bg-pressed": "#21528c",
  "button-secondary-bg-focused": "#10264100",
  "button-secondary-border": "#102641",
  "button-secondary-border-focused": "#102641",
  "button-tertiary-bg-active": "#10264100",
  "button-tertiary-bg-hover": "#10264114",
  "button-tertiary-bg-focused": "#10264100",
  "button-tertiary-bg-pressed": "#1026411f",
  "button-tertiary-bg-inactive": "#10264100",
  "button-inverse-primary-bg-active": "#8cd3f5",
  "button-inverse-primary-bg-hover": "#1fbcf8",
  "button-inverse-primary-bg-focused": "#8cd3f5",
  "button-inverse-primary-bg-pressed": "#1ba9e0",
  "button-inverse-bg-inactive": "#bbbbbb",
  "button-inverse-secondary-bg-active": "#ffffff00",
  "button-inverse-secondary-bg-hover": "#ffffff",
  "button-inverse-secondary-bg-focused": "#ffffff00",
  "button-inverse-secondary-bg-pressed": "#d3effc",
  "button-inverse-secondary-border": "#ffffff",
  "button-inverse-secondary-border-focused": "#ffffff",
  "button-inverse-tertiary-bg-active": "#8cd3f500",
  "button-inverse-tertiary-bg-hover": "#8cd3f514",
  "button-inverse-tertiary-bg-focused": "#8cd3f500",
  "button-inverse-tertiary-bg-pressed": "#8cd3f51f",
  "button-inverse-tertiary-bg-inactive": "#8cd3f500",
  "button-close-alert-error": "#48130f",
  "button-close-alert-success": "#0a2a1f",
  "button-close-alert-warning": "#332115",
  "button-close-alert-info": "#102641",
  "button-close-bg": "#102641",
  "button-close-inverse-bg": "#ffffff",
  "button-floating-content": "#102641",
  "button-floating-inverse-content": "#ffffff",
  "button-floating-content-inactive": "#747474",
  "button-floating-bg-active": "#ffffff",
  "button-floating-bg-hover": "#10264114",
  "button-floating-bg-focused": "#ffffff",
  "button-floating-bg-pressed": "#1026411f",
  "button-floating-bg-inactive": "#d1d1d1",
  "button-floating-border": "#8d8d8d",
  "button-floating-inverse-bg-active": "#21528c",
  "button-floating-inverse-bg-hover": "#1d4678",
  "button-floating-inverse-bg-focused": "#21528c",
  "button-floating-inverse-bg-pressed": "#102641",
  "button-navigation-bg-active": "#10264114",
  "button-navigation-bg-hover": "#1026411f",
  "button-navigation-bg-pressed": "#10264133",
  "button-navigation-inactive": "#10264133",
  "button-navigation-bg-inactive": "#1026410a",
  "button-navigation-bg-selected": "#21528c",
  "link-subtle": "#102641",
  "link-strong": "#2e70bd",
  "link-strong-pressed": "#102641",
  "link-subtle-pressed": "#21528c",
  "link-visited": "#b041b3",
  "link-inactive": "#8d8d8d",
  "link-inverse-subtle": "#ffffff",
  "link-inverse-strong": "#1fbcf8",
  "link-inverse-strong-pressed": "#199acc",
  "link-inverse-subtle-pressed": "#8cd3f5",
  "link-inverse-visited": "#e273e6",
  "link-inverse-inactive": "#8d8d8d",
  "icon-control-neutral_white": "#ffffff",
  "icon-control-blue900": "#102641",
  "icon-control-blue700": "#21528c",
  "icon-control-turquoise200": "#8cd3f5",
  "icon-control-inactive": "#8d8d8d",
  "icon-inverse-control-inactive": "#747474",
  "icon-display-error": "#d23627",
  "icon-inverse-display-error": "#e35a4d",
  "icon-display-success": "#1e815d",
  "icon-inverse-display-success": "#2aa277",
  "icon-display-warning": "#aa5f27",
  "icon-inverse-display-warning": "#d6772d",
  "icon-display-info": "#2e70bd",
  "icon-inverse-display-info": "#3885e1",
  "icon-display-inactive": "#747474",
  "icon-display-neutral_white": "#ffffff",
  "icon-display-blue900": "#102641",
  "icon-display-blue700": "#21528c",
  "icon-display-blue600": "#2e70bd",
  "icon-display-turquoise300": "#1fbcf8",
  "icon-display-neutral500": "#8d8d8d",
  "menu-content": "#102641",
  "menu-content-inactive": "#8d8d8d",
  "menu-content-selected-inactive": "#747474",
  "menu-bg": "#ffffff",
  "menu-bg-active": "#ffffff",
  "menu-bg-hover": "#10264114",
  "menu-bg-pressed": "#1026411f",
  "menu-bg-inactive": "#ffffff",
  "menu-bg-selected": "#2e70bd",
  "menu-bg-selected-hover": "#a4c9f5",
  "menu-bg-selected-focused": "#d8e7f9",
  "menu-bg-selected-pressed": "#7db3f2",
  "menu-bg-selected-inactive": "#e4e4e4",
  "menu-inverse-content": "#ffffff",
  "menu-inverse-content-inactive": "#747474",
  "menu-inverse-content-selected-inactive": "#555555",
  "menu-inverse-bg": "#f4f4f4",
  "menu-inverse-bg-active": "#f4f4f4",
  "menu-inverse-bg-hover": "#10264114",
  "menu-inverse-bg-pressed": "#1026411f",
  "menu-inverse-bg-inactive": "#f4f4f4",
  "menu-inverse-bg-selected": "#0f5e7c",
  "menu-inverse-bg-selected-hover": "#0c4c64",
  "menu-inverse-bg-selected-pressed": "#062835",
  "menu-inverse-bg-selected-inactive": "#bbbbbb",
  "menu-divider": "#d1d1d1",
  "menu-inverse-divider": "#8d8d8d",
  "menu-dropdown-border": "#8d8d8d",
  "menu-dropdown-scrollbar": "#d1d1d1",
  "menu-inverse-dropdown-border": "#8d8d8d",
  "menu-inverse-dropdown-scrollbar": "#747474",
  "action-icon": "#ffffff",
  "action-icon-inactive-strong": "#555555",
  "action-icon-inactive-subtle": "#8d8d8d",
  "action-inverse-icon": "#102641",
  "action-text-body": "#555555",
  "action-text-label": "#102641",
  "action-text-inactive-strong": "#555555",
  "action-text-inactive-subtle": "#8d8d8d",
  "action-inverse-text-body": "#e4e4e4",
  "action-inverse-text-label": "#ffffff",
  "action-fill": "#ffffff",
  "action-fill-unselected-hover": "#10264114",
  "action-fill-unselected-pressed": "#1026411f",
  "action-fill-selected": "#21528c",
  "action-fill-selected-hover": "#1d4678",
  "action-fill-selected-pressed": "#102641",
  "action-inverse-fill-active": "#102641",
  "action-inverse-fill-unselected-hover": "#1fbcf829",
  "action-inverse-fill-unselected-pressed": "#1fbcf83d",
  "action-inverse-fill-selected": "#8cd3f5",
  "action-inverse-fill-selected-hover": "#1fbcf8",
  "action-inverse-fill-selected-pressed": "#1ba9e0",
  "action-fill-selected-inactive": "#bbbbbb",
  "action-inverse-fill-selected-inactive": "#8d8d8d",
  "action-bg-selected-inactive": "#d1d1d1",
  "action-inverse-bg-selected-inactive": "#bbbbbb",
  "action-stroke-active": "#8d8d8d",
  "action-stroke-hover": "#10264114",
  "action-stroke-pressed": "#1026411f",
  "action-inverse-stroke-active": "#ffffff",
  "action-inverse-stroke-hover": "#1fbcf829",
  "action-inverse-stroke-pressed": "#1fbcf83d",
  "action-stroke-inactive": "#bbbbbb",
  "action-inverse-stroke-inactive": "#8d8d8d",
  "action-stroke-selected": "#2e70bd",
  "action-inverse-stroke-strong-hover": "#1fbcf83d",
  "action-inverse-stroke-strong-pressed": "#1fbcf87a",
  "switch-bg-unselected-active": "#8d8d8d",
  "switch-bg-unselected-inactive": "#bbbbbb",
  "switch-bg-selected-active": "#a4c9f5",
  "switch-bg-selected-inactive": "#8d8d8d",
  "switch-inverse-bg-unselected-inactive": "#8d8d8d",
  "switch-inverse-bg-selected-active": "#147aa2",
  "switch-inverse-bg-selected-inactive": "#bbbbbb",
  "switch-fill-unselected-active": "#ffffff",
  "switch-fill-unselected-inactive": "#d1d1d1",
  "switch-fill-selected-active": "#21528c",
  "switch-fill-selected-hover": "#1d4678",
  "switch-fill-selected-pressed": "#102641",
  "switch-fill-selected-inactive": "#bbbbbb",
  "switch-inverse-fill-unselected-active": "#ffffff",
  "switch-inverse-fill-selected": "#8cd3f5",
  "switch-inverse-fill-selected-hover": "#1fbcf8",
  "switch-inverse-fill-selected-pressed": "#1ba9e0",
  "switch-inverse-fill-selected-inactive": "#747474",
  "switch-stroke-hover": "#10264114",
  "switch-stroke-pressed": "#1026411f",
  "switch-stroke-unselected-active": "#8d8d8d",
  "switch-inverse-stroke-hover": "#1fbcf829",
  "switch-inverse-stroke-pressed": "#1ba9e03d",
  divider: "#d1d1d1",
  "divider-inverse": "#747474",
  "divider-label-bg": "#10264114",
  "divider-inverse-label-bg": "#8cd3f51f",
  "tabs-text": "#102641",
  "tabs-text-selected": "#21528c",
  "tabs-text-inverse": "#ffffff",
  "tabs-inverse-text-selected": "#8cd3f5",
  "tabs-border": "#21528c",
  "tabs-inverse-border": "#8cd3f5",
  "tabs-bg-selected": "#ffffff",
  "tabs-text-inactive": "#8d8d8d",
  "field-label": "#555555",
  "field-input": "#102641",
  "field-placeholder": "#8d8d8d",
  "field-label-error": "#d23627",
  "field-message-default": "#555555",
  "field-message-error": "#d23627",
  "field-message-success": "#2aa277",
  "field-inactive": "#8d8d8d",
  "field-icon": "#8d8d8d",
  "field-icon-control": "#102641",
  "field-icon-error": "#e35a4d",
  "field-icon-success": "#2aa277",
  "field-icon-inactive": "#8d8d8d",
  "field-bg-dark": "#fbfbfb",
  "field-bg-light": "#ffffff",
  "field-border-active": "#8d8d8d",
  "field-border-hover": "#555555",
  "field-border-engaged": "#3885e1",
  "field-border-error": "#e35a4d",
  "field-border-hover-error": "#aa2e23",
  "field-border-engaged-error": "#e35a4d",
  "field-border-inactive": "#bbbbbb",
  "field-inverse-label": "#d1d1d1",
  "field-inverse-input": "#ffffff",
  "field-inverse-placeholder": "#8d8d8d",
  "field-inverse-label-error": "#e3837a",
  "field-inverse-message-default": "#bbbbbb",
  "field-inverse-message-error": "#e3837a",
  "field-inverse-message-success": "#2aa277",
  "field-inverse-inactive": "#8d8d8d",
  "field-inverse-icon": "#8d8d8d",
  "field-inverse-icon-control": "#ffffff",
  "field-inverse-icon-error": "#e35a4d",
  "field-inverse-icon-success": "#2aa277",
  "field-inverse-icon-inactive": "#8d8d8d",
  "field-inverse-bg": "#102641",
  "field-inverse-border-active": "#8d8d8d",
  "field-inverse-border-hover": "#bbbbbb",
  "field-inverse-border-engaged": "#1fbcf8",
  "field-inverse-border-error": "#e35a4d",
  "field-inverse-border-hover-error": "#e3837a",
  "field-inverse-border-engaged-error": "#e35a4d",
  "field-inverse-border-inactive": "#8d8d8d",
  "modal-overlay": "#121212b8",
  "modal-bg-subtle": "#ffffff",
  "modal-bg-strong": "#fbfbfb",
  "modal-inverse-bg": "#102641"
}

export default fustionColorPalette;
